<template>
  <div class="message-history__message">
    <div
      :class="{'pull-right': fromCustomer}"
      class="small"
      v-text="formattedDate"
    />

    <div class="clearfix" />

    <div
      :class="{
        'from-me': fromCustomer,
        'primary-bg': fromCustomer,
        'secondary-bg': !fromCustomer,
        'pull-right': fromCustomer
      }"
      class="bubble"
    >
      <pre><span>{{ message.message.trim() }}</span></pre>
    </div>
    <div class="clearfix" />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },

  computed: {
    fromCustomer() {
      return this.message.is_from_customer;
    },

    formattedDate() {
      return moment(this.message.created_at).calendar();
    },
  },
};
</script>

<style lang="scss">
.message-history__message {
  $triangle-size: 5px;
  margin-top: 1em;

  .bubble {
    position: relative;
    padding: 1em;
    margin-top: $triangle-size;
    border-radius: 5px;

    width: 90%;

    pre {
      background: inherit;
      color: inherit;
      border: 0 none;
      margin: 0;
      padding: 0;
      border-radius: 0;
      font: inherit;
      white-space:pre-wrap;
    }
  }

  .bubble:after {
    content: '';
    position: absolute;
    top: 0;
    left: 5%;
    width: 0;
    height: 0;
    border: $triangle-size solid transparent;
    border-top: 0;
    margin-left: -$triangle-size;
    margin-top: -$triangle-size;
  }

  .bubble.from-me:after {
    left: 95%;
  }
}
</style>
